
import { GridCellCommonPropsType, GridColumnCommonOptionsType } from '../../../enums';
import { StyleColorSchemeType } from '../../../../../styles/enums';
import { CommonCellProps } from './mixins/common-cell-props';
import { GridSizeStylesProps, GridSizeStylesMethods } from '../../../mixins/grid-size-styles';
import GridStickyCell from '../../../mixins/grid-sticky-cell';

const DEFAULT_PLACEHOLDER = 'Not Applicable';

export default {
  name: 'GridBodyRowCell',
  mixins: [CommonCellProps, GridSizeStylesProps, GridSizeStylesMethods, GridStickyCell],
  computed: {
    isSticky() {
      return !!this.options[GridColumnCommonOptionsType.IsSticky];
    },
    style() {
      return this.getStickyStyles(this.options, this.stickyPosition);
    },
    hasValue() {
      const isNullOrUndefined = this.cell[GridCellCommonPropsType.Value] == null;

      return !isNullOrUndefined;
    },
    emptyCellPlaceholder() {
      return this.options[GridColumnCommonOptionsType.EmptyCellPlaceholder] || DEFAULT_PLACEHOLDER;
    },
    cellClassNames() {
      const colorSchema = this.cell[GridCellCommonPropsType.ColorSchema];
      const fillColorSchema = this.cell[GridCellCommonPropsType.FillColorSchema];

      return this.getClassNamesBuilderWithSizeClassNames('grid-body-row-cell')
        .addConditionClassNames(Object.values(StyleColorSchemeType), colorSchema)
        .addConditionClassName(`fill-${fillColorSchema}`, !!fillColorSchema)
        .addConditionClassName('sticky', this.isSticky)
        .build();
    },
  },
};
